import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.sm-media.id';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Password tidak cocok'); return; }
    if (password.length < 6) { setError('Password minimal 6 karakter'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal reset password');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'linear-gradient(135deg, #0a0e1a 0%, #111827 100%)' }}>
      <div style={{ width: '100%', maxWidth: 400, background: '#111827', border: '1px solid #1e2d45', borderRadius: 16, padding: 32 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 24 }}>
          <span style={{ fontSize: 32, fontWeight: 700, background: 'linear-gradient(135deg, #f59e0b, #fbbf24)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>SM</span>
          <span style={{ fontSize: 14, fontWeight: 600, color: '#94a3b8', letterSpacing: 3 }}>MEDIA</span>
        </div>
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: '#f1f5f9', marginBottom: 8 }}>Password Berhasil Direset!</h2>
            <p style={{ color: '#94a3b8', fontSize: 14 }}>Redirect ke login dalam 3 detik...</p>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>Reset Password</h1>
            <p style={{ fontSize: 14, color: '#94a3b8', marginBottom: 28 }}>Masukkan password baru kamu</p>
            {error && <div style={{ background: '#450a0a', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>{error}</div>}
            {!token ? (
              <div style={{ textAlign: 'center', color: '#ef4444' }}>Link tidak valid. <Link to="/forgot-password" style={{ color: '#f59e0b' }}>Minta link baru</Link></div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 14 }}>
                  <label style={{ display: 'block', fontSize: 13, color: '#94a3b8', marginBottom: 6 }}>Password Baru</label>
                  <input type="password" placeholder="Min 6 karakter" value={password} onChange={e => setPassword(e.target.value)} required style={{ fontSize: 16 }} />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: 'block', fontSize: 13, color: '#94a3b8', marginBottom: 6 }}>Konfirmasi Password</label>
                  <input type="password" placeholder="Ulangi password baru" value={confirm} onChange={e => setConfirm(e.target.value)} required style={{ fontSize: 16 }} />
                </div>
                <button type="submit" className="btn btn-gold" style={{ width: '100%', padding: 14, fontSize: 16 }} disabled={loading}>
                  {loading ? 'Menyimpan...' : 'Reset Password'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}
